import { MinimalStatusCollection } from '@/generated/model';
import { Polyline, LatLngExpression } from 'leaflet';

function getLL(p: MinimalStatusCollection): LatLngExpression[] | undefined {
  return p.positions?.map((pp) => ({
    lat: pp.latitude,
    lng: pp.longitude,
  }));
}

export function calcSections(pos: MinimalStatusCollection[]): Polyline {
  const sections: LatLngExpression[][] = [];

  pos.forEach((p) => {
    const ll = getLL(p);
    if (ll) {
      sections.push(ll);
    }
  });

  return new Polyline(sections);
}

/*
tile meretbol kiindulni
tavolsag felenel az elso nyil
simplify

TODO vagy ne legyen ArrowMarker tsx es css vagy a decorator azt hasznalja
de ne legyen 2x
*/
